/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MediaTypeItem } from '../../models/media-type-item';
import { UpdateMediaTypeDto } from '../../models/update-media-type-dto';

export interface MediaTypeControllerUpdate$Params {
  id: string;
      body: UpdateMediaTypeDto
}

export function mediaTypeControllerUpdate(http: HttpClient, rootUrl: string, params: MediaTypeControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaTypeItem;
}>> {
  const rb = new RequestBuilder(rootUrl, mediaTypeControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MediaTypeItem;
      }>;
    })
  );
}

mediaTypeControllerUpdate.PATH = '/file-manager/types/{id}';
